import React, { useState } from "react";

import { getValue } from "../../utils";

import { Div, BigOutlineButton, Text1 } from "components/Base";
import MiniModalWrapper from "ui-kit/MiniModalWrapper";

import { noop } from "utils/General";
import { ROW_ACTIONS } from "../../constants";

import { connect } from "react-redux";
import { bindInstance } from "redux-mvc";

import { actions } from "../../model";

const CampaignDetails = ({
  sent_by = "",
  recipients_count = 0,
  sent_at = "",
  unique_opens = 0,
  unique_clicks = 0,
  openRecipientsModal = noop
}) => (
  <Div
    bg="white"
    display="row.space-between.stretch"
    height={1}
    br={1}
    bc="neutral2"
    p={4}
    style={{
      width: "30%"
    }}
  >
    <Div
      display="column.flex-start.center"
      width={1}
      bc="neutral2"
      ba={1}
      p={2}
    >
      <Div
        display="row.space-between.stretch"
        width={1}
        bc="neutral2"
        bb={1}
        p={2}
      >
        <Text1 color="neutral7" bold uppercase>
          SENT BY
        </Text1>
        <Text1 color="neutral7">{sent_by}</Text1>
      </Div>
      <Div
        display="row.space-between.stretch"
        width={1}
        bc="neutral2"
        bb={1}
        p={2}
      >
        <Text1 color="neutral7" bold uppercase>
          SENT AT
        </Text1>
        <Text1 color="neutral7">{sent_at}</Text1>
      </Div>
      <Div
        display="row.space-between.stretch"
        width={1}
        bc="neutral2"
        bb={1}
        p={2}
      >
        <Text1 color="neutral7" bold uppercase>
          Recipients list
        </Text1>
        <Text1
          color="blue"
          onClick={openRecipientsModal}
          style={{
            fontSize: "15px",
            fontWeight: 600,
            color: "#2e70e2",
            cursor: "pointer"
          }}
        >
          view recipients
        </Text1>
      </Div>
      <Div
        display="row.space-between.stretch"
        width={1}
        bc="neutral2"
        bb={1}
        p={2}
      >
        <Text1 color="neutral7" bold uppercase>
          TOTAL RECIPIENTS
        </Text1>
        <Text1 color="neutral7">{recipients_count}</Text1>
      </Div>
      <Div
        display="row.space-between.stretch"
        width={1}
        bc="neutral2"
        bb={1}
        p={2}
      >
        <Text1 color="neutral7" bold uppercase>
          UNIQUE OPENS
        </Text1>
        <Text1 color="neutral7">{unique_opens}</Text1>
      </Div>
      <Div
        display="row.space-between.stretch"
        width={1}
        bc="neutral2"
        bb={1}
        p={2}
      >
        <Text1 color="neutral7" bold uppercase>
          UNIQUE CLICKS
        </Text1>
        <Text1 color="neutral7">{unique_clicks}</Text1>
      </Div>
    </Div>
  </Div>
);

const EmailContent = ({ subject, content }) => (
  <Div
    bg="neutral0"
    flex={1}
    display="column.space-between.stretch"
    height={1}
    p={4}
    style={{
      overflowY: "auto"
    }}
  >
    <Div display="row.flex-start.center" width={1} bg="white" p={4} mb={4}>
      <Text1 color="neutral6" bold mr={2}>
        Subject:
      </Text1>
      <Text1 color="neutral7" bold>
        {subject}
      </Text1>
    </Div>
    <Div
      display="column.flex-start.stretch"
      width={1}
      bg="white"
      p={4}
      height={1}
    >
      <span dangerouslySetInnerHTML={{ __html: content }} />
    </Div>
  </Div>
);

const EmailCampaignModal = ({
  closeModal = noop,
  campaignData,
  emailContent,
  emailSubject,
  openRecipientsModal = noop
}) => (
  <MiniModalWrapper
    hideModal={closeModal}
    isPortal={false}
    showModal
    title="View Campaign Details"
    display="column.flex-start.stretch"
    zIndex={300}
    style={{
      width: "90%",
      height: "90vh"
    }}
    bg="neutral0"
  >
    <Div bg="white" width={1} height={1} display="column.space-between.stretch">
      <Div
        display="row.center.center"
        width={1}
        style={{
          height: "calc(100% - 70px)"
        }}
      >
        <Div
          bg="white"
          flex={1}
          display="row.space-between.stretch"
          height={1}
          width={1}
        >
          <CampaignDetails
            {...campaignData}
            openRecipientsModal={openRecipientsModal}
          />
          <EmailContent subject={emailSubject} content={emailContent} />
        </Div>
      </Div>

      <Div
        display="row.flex-start.center"
        px={6}
        py={4}
        style={{ borderTop: "1px solid #e7e6ea" }}
        bg="white"
      >
        <BigOutlineButton onClick={closeModal}>Close</BigOutlineButton>
      </Div>
    </Div>
  </MiniModalWrapper>
);

const decorate = connect(
  null,
  bindInstance({
    execute: actions.executeAction
  })
);

const EmailCampaignFormatter = props => {
  const [showModal, setShowModal] = useState(false);

  const subject = getValue(props, "subject");
  const content = getValue(props, "content");
  const campaignData = getValue(props);
  const id = props?.data?.id;

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        width: "100%"
      }}
    >
      <div
        title={subject}
        className="underline-on-hover"
        style={{
          fontSize: "16px",
          fontWeight: 600,
          color: "#2e70e2",
          width: "100%",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          cursor: "pointer"
        }}
        onClick={() => {
          setShowModal(true);
          props.execute({
            actionId: ROW_ACTIONS.OPEN_EMAIL_CAMPAIGN_MODAL,
            id
          });
        }}
      >
        {subject}
      </div>
      {showModal && (
        <EmailCampaignModal
          campaignData={campaignData}
          emailContent={content}
          emailSubject={subject}
          closeModal={() => setShowModal(false)}
          openRecipientsModal={() => {
            props.execute({
              actionId: ROW_ACTIONS.OPEN_EMAIL_RECIPIENTS_MODAL,
              id
            });
          }}
        />
      )}
    </div>
  );
};
export default decorate(EmailCampaignFormatter);
